import seshes from "./SeshAPI";
import spots from "./SpotAPI";

const api = { seshes, spots };
export default api;
